/** Role names as identity-api sends them in `User.role`. */
export const ROLES = {
  SUPER_ADMIN: 'SUPER_ADMIN',
} as const;
